var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"title",rawName:"v-title"}],attrs:{"id":"app","data-title":"Professional Pronunciation Assessment API | Dolphin AI"}},[(_vm.Loaded)?_c('HeaderVue'):_vm._e(),(_vm.Loaded)?_c('router-view'):_vm._e(),(_vm.Loaded)?_c('FooterVue'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }